import Vue from 'vue'
import {getToken, qrToken, getRsaPublicKey, getUserInfo, logout, switchDept,refreshToken} from '../../api/login'
import {menuLoad, getAccountDepart, appLoad} from '../../api/manage'

const user = {
  state: {
    token: '',
    rsaPublicKey: '',
    id: '',
    name: '',
    avatar: '',
    apps: [],
    menus: [],
    departs: [],
    currentMenuCode: '',//当前所处菜单标识
    info: {},
    refreshToken: ''
  },

  mutations: {

    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_RSAPUBLICKEY: (state, rsaPublicKey) => {
      state.rsaPublicKey = rsaPublicKey
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_APPS: (state, apps) => {
      state.apps = apps
    },
    SET_DEPARTS: (state, departs) => {
      state.departs = departs
    },
    SET_CURRENTMENUCODE: (state, currentMenuCode) => {
      state.currentMenuCode = currentMenuCode
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_REFRESHTOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken
    },
  },

  actions: {

    // 登录获取Token
    GetToken({commit}, code) {
      return new Promise((resolve, reject) => {
        getToken(code).then(d => {
          Vue.ss.set('token', d.access_token, d.expires_in * 1000)
          Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
          commit('SET_REFRESHTOKEN', d.refresh_token)
          commit('SET_TOKEN', d.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 二维码登录获取Token
    QrToken({commit}, {code, uuid}) {
      return new Promise((resolve, reject) => {
        qrToken(code, uuid).then(d => {
          Vue.ss.set('token', d.access_token, d.expires_in * 1000)
          Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
          commit('SET_TOKEN', d.access_token)
          commit('SET_REFRESHTOKEN', d.refresh_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    SetToken({commit}, token) {
      return new Promise(resolve => {
        Vue.ss.set('token', token, 10800 * 1000)
        commit('SET_TOKEN', token)
        resolve()
      })
    },

    /**
     * 设置当前点击菜单
     * @param commit
     * @param menucode
     * @constructor
     */
    SetCurrentMenuCode({commit}, menucode) {
      return new Promise(resolve => {
        Vue.ss.set('menucode', menucode)
        commit('SET_CURRENTMENUCODE', menucode)
        resolve()
      })
    },

    // 获取Rsa公钥
    GetRsaPublicKey({commit}) {
      return new Promise((resolve, reject) => {
        getRsaPublicKey().then(d => {
          Vue.ss.set('rsaPublicKey', d.key1, d.expires_in * 1000)
          commit('SET_RSAPUBLICKEY', d.key1)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const d = res.result;
          commit('SET_ID', d.account_id)
          commit('SET_NAME', d.personname)
          commit('SET_INFO', d)

          // 加载应用
          if (d.deptuuid) {
            appLoad(d.account_id, d.deptuuid).then(x => {
              commit('SET_APPS', x)
              menuLoad(x[0].app_uuid, d.account_id, d.deptuuid, d.manageunituuid).then(o => {
                commit('SET_MENUS', o)
              })
            })
          } else {
            // 加载菜单
            menuLoad(d.appuuid, d.account_id, d.deptuuid, d.manageunituuid).then(o => {
              commit('SET_MENUS', o)
            })
          }

          // 加载部门
          getAccountDepart(d.account_id).then(o => {
            commit('SET_DEPARTS', o)
          })
          resolve(d)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 切换部门
    SwitchDepart({commit}, depart) {
      return new Promise((resolve, reject) => {
        switchDept(depart).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout({commit}) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_RSAPUBLICKEY', '')
        commit('SET_REFRESHTOKEN', '')

        logout().then(() => {
          Vue.ss.clear();
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
    //刷新token
    RefreshToken({commit}, token){
      return new Promise((resolve, reject) => {
        refreshToken(token).then(d => {
          Vue.ss.set('token', d.access_token, d.expires_in * 1000)
          Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
          commit('SET_REFRESHTOKEN', d.refresh_token)
          commit('SET_TOKEN', d.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user